// Carrental is yet to get it's own seo setup
export { FlightSeo as CarrentalSeo } from './FlightSeo';
